import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Form, Row, Table } from 'react-bootstrap'
import BtnBack from '../../../../btn-back'
import { getLeaveAPI } from '../../../../../services/welfare-leave'
import { Image } from 'react-bootstrap'
import Calendar from './../../../../../images/calendar.svg'
import { useSearchParams } from 'react-router-dom'
import { BsPlusLg } from 'react-icons/bs'
import ModalLeaveAdd from './modal-leave-add'
import iconEdit from '../../../../../images/Edit.svg'
import ModalLeaveEdit from './modal-leave-edit'
import useDecimalInput from '../../../../../helper/input-fix-decimal'
import { formatLeaveDuration } from '../../../../../helper/fnLeaveDuration'
import UseCheckStatusAdmin from '../../../../../hooks/use-check-status-admin'
import { useSelector } from 'react-redux'
export default function EmpWelfareLeave() {
  const statusAdmin = UseCheckStatusAdmin()

  // let [searchParams, setSearchParams] = useSearchParams()
  // const orgId = searchParams.get('orgId')
  // const code = searchParams.get('code')

  const { profile } = useSelector((state) => state.profileReducer)

  const orgId = profile?.orgId
  const code = profile?.code

  const param = { orgId, code }

  const inputRef = useRef(null)
  const handleKeyDownNum = useDecimalInput(inputRef)

  const [dataTable, setDataTable] = useState([])

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalEditOpen, setIsModalEditOpen] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  useEffect(() => {
    if (orgId && code) {
      getLeave()
    }
    return () => {}
  }, [orgId, code])

  const getLeave = async () => {
    const result = await getLeaveAPI(param)
    if (!result) return
    if (result.status) {
      setDataTable(result.result)
    }
  }
  const showModalAddOpen = () => {
    setIsModalOpen(true)
  }

  const handleModalAddClose = () => {
    setIsModalOpen(false)
  }

  const showModalEditOpen = () => {
    setIsModalEditOpen(true)
  }

  const handleModalEditClose = () => {
    setIsModalEditOpen(false)
  }

  return (
    <>
      <div className="" border="0" style={{ margin: '20px' }}>
        <BtnBack text={'สิทธิลา'} className={''} />
      </div>
      <Row>
        <Col xl={12}>
          <Row>
            <Col xl={6} className="align-content-around">
              {/* Calendar */}

              <span className="align-middle">
                <Image
                  src={Calendar}
                  className="d-flexme-3 "
                  style={{
                    height: '45px',
                    width: '45px',
                    border: '0',
                    marginLeft: '30px',
                    marginRight: '10px',
                    marginTop: '10px',
                    marginBottom: '20px'
                  }}
                />
                <span className="fw-bold my-auto me-2">มีสิทธิลา </span>
              </span>
            </Col>
            <Col xl={6}>
              {/* Add Button */}
              {statusAdmin?.status_id === 1 && (
                <div className="d-flex justify-content-end mb-3 me-5">
                  <Button size="sm" className="" style={{ minWidth: '200px' }} onClick={showModalAddOpen}>
                    <BsPlusLg /> Add Leave
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </Col>{' '}
      </Row>

      <Card border="0">
        <Col
          xl={12}
          className="mt-3"
          style={{ maxHeight: '65vh', overflow: 'auto' }}
        >
          <Table hover striped>
            <thead
              style={{
                position: 'sticky',
                top: '0px',
                height: '3rem',
                backgroundColor: '#fff',
                zIndex: 1
              }}
            >
              <tr>
                <th className="fw-normal ">ประเภทการลา</th>
                <th className="fw-normal text-center">สิทธิการลาทั้งหมด</th>
                <th className="fw-normal text-center">วันลาสะสม</th>
                <th className="fw-normal text-center">ใช้แล้ว</th>
                <th className="fw-normal text-center ">คงเหลือ</th>
                <th className="fw-normal text-center ">Action</th>
              </tr>
            </thead>

            <tbody>
              {dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="fw-light">
                    <td>{d.leave_type}</td>
                    <td className="text-center">{formatLeaveDuration(d.total, d.work_hour)}</td>
                    <td className="text-center">{formatLeaveDuration(d.carry, d.work_hour)}</td>
                    <td className="text-center">{formatLeaveDuration(d.used, d.work_hour)}</td>
                    <td className="text-center">{formatLeaveDuration(d.remain, d.work_hour)}</td>
                    <td className="text-center">
                      <span className="me-2">
                        <Image
                          className=" pointer-event"
                          style={{
                            width: '20px'
                          }}
                          onClick={() => {
                            setDataEdit(d)
                            setIsModalEditOpen(true)
                          }}
                          src={iconEdit}
                        />{' '}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    - No Data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
        {/* </Row> */}
      </Card>
      {isModalOpen && (
        <ModalLeaveAdd
          handleModalAddClose={handleModalAddClose}
          showModalAddOpen={showModalAddOpen}
          isModalOpen={isModalOpen}
          isSave={isSave}
          setIsSave={setIsSave}
          orgId={orgId}
          code={code}
          getLeave={getLeave}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
      {isModalEditOpen && (
        <ModalLeaveEdit
          handleModalEditClose={handleModalEditClose}
          showModalEditOpen={showModalEditOpen}
          isModalEditOpen={isModalEditOpen}
          isSave={isSave}
          setIsSave={setIsSave}
          orgId={orgId}
          code={code}
          getLeave={getLeave}
          dataEdit={dataEdit}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
    </>
  )
}
